import Image from '@components/Image';
import {
  ImageType,
  type STMapMarker,
  type STMapMarkerScene,
  STMapMarkerType,
} from '@types';
import cn from '@utils/cn';
import type { CSSProperties } from 'react';

interface Props {
  marker: STMapMarker;
  className?: string;
}

const iconStyle = (icon: STMapMarkerScene['icon']): CSSProperties => ({
  width: 16,
  height: 16,
  border: `2px solid rgba(${icon.borderColor})`,
  backgroundColor: `rgba(${icon.fillColor})`,
});

export function MapMarkerIcon({ marker, className }: Props) {
  const cx = cn('w-16 h-16 shrink-0', className);

  switch (marker.type) {
    case undefined:
    case STMapMarkerType.scene:
    case STMapMarkerType.point: {
      if (marker.icon.type === 1) {
        return (
          <Image
            className={cx}
            type={
              marker.icon.mediaIcon?.type === 0
                ? ImageType.sysMedia
                : ImageType.media
            }
            src={marker.icon.mediaIcon?.url || ''}
            size={16}
          />
        );
      }
      return (
        <div className="shrink-0 rounded-full" style={iconStyle(marker.icon)} />
      );
    }
    case STMapMarkerType.image: {
      return (
        <Image
          className={cx}
          type={
            marker.icon.image.type === 0 ? ImageType.sysMedia : ImageType.media
          }
          src={marker.icon.image.url}
          size={16}
          objectFit="contain"
        />
      );
    }
    case STMapMarkerType.text:
      return (
        <Image
          className={cx}
          type={ImageType.sysMedia}
          src={'/imgs/img-text.baf6c7c78c5de0678e714f7c7a72612a.png'}
          size={16}
        />
      );
    case STMapMarkerType.polyline: {
      return (
        <Image
          className={cx}
          type={ImageType.sysMedia}
          src={'/imgs/img-polyline.ae101048fdefcf4a1e9b4296b8213b25.png'}
          size={16}
        />
      );
    }
    case STMapMarkerType.polygon:
      return (
        <Image
          className={cx}
          type={ImageType.sysMedia}
          src={'/imgs/img-polygon.bc9f95293fbb66c8f14f855e64b44491.png'}
          size={16}
        />
      );
    case STMapMarkerType.circle:
      return (
        <Image
          className={cx}
          type={ImageType.sysMedia}
          src={'/imgs/img-circle.f105a952be1ea9d5cfd742d1b3b2d9b0.png'}
          size={16}
        />
      );
    case STMapMarkerType.pulse:
      return (
        <Image
          className={cx}
          type={ImageType.sysMedia}
          src={'/imgs/img-pulse.4b184f3c410195da9666a4df01cf7d68.png'}
          size={16}
        />
      );
    default:
      return <div className={cx} />;
  }
}
